// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'

import { FixedTextInput } from '../../'


export const Option = ({ disabled, order, text='', onChange, editButton, onClick, active, focus }) => (
  <div
    className='slds-size_1-of-1 slds-p-around_small slds-m-bottom_small clickable'
    style={{ border: `${active ? '2' : '1'}px solid ${active ? 'green' : 'darkgrey'}`, backgroundColor: disabled ? '#f5f5f5' : 'white' }}
    onClick={onClick}>

    <FixedTextInput
      text={<span>- <b>{order}</b> for </span>}
      value={text}
      postText={editButton}
      onChange={onChange}
      onClick={e => {
        e.stopPropagation()
        focus()
      }}
      disabled={disabled}
      bare={true}
      className='clickable whatsapp-option-input'
    />
  </div>
)

Option.propTypes = {
  disabled: PropTypes.bool,
  order: PropTypes.number.isRequired,
  text: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  editButton: PropTypes.element,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  focus: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-whatsapp-editor/Option.js